import { createContext, useContext } from "react";
const TopicPageContext = createContext({
    disabled: true,
    isPartOfTopic: false,
    isOwner: false,
    isOwnerOrAdmin: false
});
export function useTopicPage() {
    return useContext(TopicPageContext);
}
export const TopicPageProvider = TopicPageContext.Provider;
export const TopicPageConsumer = TopicPageContext.Consumer;
